import React, { useRef, useEffect, useCallback, useState} from 'react';
import CellInner from "components/effects/jaki/CellInner.js";
import {connect} from 'react-redux';
import './jtypes.scss';

const JTypes = ({jtypes, probabilities}) => { 
    let [mouseDown, setMouseDown] = useState(false);

    useEffect(() => {
        window.addEventListener("mouseup", onMouseUp);
        return () => window.removeEventListener("mouseup", onMouseUp);
    }, [setMouseDown]);

    const onMouseUp = useCallback(() => {
        setMouseDown(false);
    }, [setMouseDown]);


    if (!jtypes || !jtypes.probabilities) {
        return '';
    }
    return (<div className="jaki-grid j-types">
              <Type
                probabilities={probabilities}
                mouseDown={mouseDown}
                setMouseDown={setMouseDown}
                type="rest" jtypes={jtypes}/>
              <Type
                probabilities={probabilities}
                mouseDown={mouseDown}
                setMouseDown={setMouseDown}
                type="pianissimo" jtypes={jtypes}/>
              <Type
                probabilities={probabilities}
                mouseDown={mouseDown}
                setMouseDown={setMouseDown}
                type="piano" jtypes={jtypes}/>
              <Type
                probabilities={probabilities}
                mouseDown={mouseDown}
                setMouseDown={setMouseDown}
                type="regular" jtypes={jtypes}/>
              <Type
                probabilities={probabilities}
                mouseDown={mouseDown}
                setMouseDown={setMouseDown}
                type="accent" jtypes={jtypes}/>
              <Type
                probabilities={probabilities}
                mouseDown={mouseDown}
                setMouseDown={setMouseDown}
                type="staccato" jtypes={jtypes}/>
              <Type
                probabilities={probabilities}
                mouseDown={mouseDown}
                setMouseDown={setMouseDown}
                type="legato" jtypes={jtypes}/>
              <Type
                probabilities={probabilities}
                mouseDown={mouseDown}
                setMouseDown={setMouseDown}
                type="double" jtypes={jtypes}/>
              <Type
                probabilities={probabilities}
                mouseDown={mouseDown}
                setMouseDown={setMouseDown}
                type="flam" jtypes={jtypes}/>
            </div>);
}

const Type = ({probabilities, mouseDown, setMouseDown, type, jtypes, height=80}) => {
    let [probability, setProbability] = useState(jtypes.probabilities[type] || 0);
    let ref = useRef();

    useEffect(() => {
        setProbability(probabilities[type]);
    }, [setProbability, probabilities]);

    const onMouseMove = useCallback((e) => {
        if (!mouseDown) {
            return false;
        }
        let rect = ref.current.getBoundingClientRect();
        let y = height - (e.clientY - rect.top);
        let ratio = y/height;
        setProbability(ratio);
        jtypes.setProbability(type, ratio);
    }, [setProbability, mouseDown, height]);

    return (
        <div ref={ref} className="j-type">
          <div
            onMouseUp={() => setMouseDown(false)}
            onMouseDown={(e) => {
                e.stopPropagation();
                setMouseDown(true);
            }}
            onMouseMove={onMouseMove}
            className="j-slider">
            <div
              style={{height: height * probability}}
              className="j-slider-inner">
            </div>
          </div>
          <div className="cell">
            <CellInner cell={{type}}/>
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      probabilities: props.jtypes.probabilities
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JTypes);
